import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconCircleCheck, IconArrowRight, IconReceipt } from "@tabler/icons-react";
import { useI18n } from "@/contexts/I18nContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { lang } = useI18n();
  const orderID = params.get("orderID") || "";
  const captureID = params.get("captureID") || "";
  const amount = params.get("amount") || "";
  const currency = (params.get("currency") || "USD").toUpperCase();
  const redirect = params.get("redirect") || "/app/billing";

  return (
    <>
      <div className="subbar">
        <span className="t">{lang === "es" ? "Pago confirmado" : "Payment confirmed"}</span>
      </div>
      <div className="wrap-app max-w-[720px] py-10" data-testid="checkout-success-page">
        <div className="card border-l-[4px] border-l-oktext bg-okbg">
          <div className="flex items-start gap-3">
            <IconCircleCheck size={40} className="text-oktext shrink-0" />
            <div className="flex-1">
              <p className="lbl m-0 text-oktext">
                {lang === "es" ? "Compra exitosa" : "Purchase successful"}
              </p>
              <h1 className="font-display text-[24px] font-medium mt-1">
                {lang === "es" ? "¡Gracias por tu compra!" : "Thank you for your purchase!"}
              </h1>
              <p className="text-muted text-[13.5px] mt-2 leading-relaxed">
                {lang === "es"
                  ? "Tu pago se procesó correctamente. El acceso al contenido ya está disponible en tu cuenta."
                  : "Your payment was processed successfully. Access to the content is now available in your account."}
              </p>

              <div className="grid sm:grid-cols-2 gap-3 mt-5">
                <div className="p-3 rounded-lg bg-white border border-line">
                  <p className="lbl m-0 text-tert">{lang === "es" ? "Total pagado" : "Amount"}</p>
                  <p className="font-display text-[22px] font-medium text-teal-deep mt-1" data-testid="success-amount">
                    ${amount ? Number(amount).toFixed(2) : "—"} <span className="text-tert text-[11px]">{currency}</span>
                  </p>
                </div>
                <div className="p-3 rounded-lg bg-white border border-line">
                  <p className="lbl m-0 text-tert">{lang === "es" ? "Estado" : "Status"}</p>
                  <p className="font-display text-[17px] font-medium text-oktext mt-1">COMPLETED</p>
                </div>
                <div className="p-3 rounded-lg bg-white border border-line sm:col-span-2">
                  <p className="lbl m-0 text-tert">{lang === "es" ? "Referencia PayPal" : "PayPal reference"}</p>
                  <p className="font-mono text-[11.5px] mt-1 break-all" data-testid="success-order-id">
                    Order: <span className="text-teal-deep">{orderID || "—"}</span>
                  </p>
                  {captureID && (
                    <p className="font-mono text-[11.5px] break-all" data-testid="success-capture-id">
                      Capture: <span className="text-teal-deep">{captureID}</span>
                    </p>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mt-6">
                <button className="btn text-[13px]" onClick={() => nav(redirect)} data-testid="success-continue">
                  {lang === "es" ? "Acceder ahora" : "Access now"} <IconArrowRight size={13} />
                </button>
                <button className="btn-ghost btn text-[13px]" onClick={() => nav("/app/billing")} data-testid="success-history">
                  <IconReceipt size={13} /> {lang === "es" ? "Ver historial" : "See history"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
